<template>
  <!-- <div class="loginPopUp">
    <div class="bg"></div>
    <div class="body_pop_up">
      <h4>{{ $t('login.heading') }}</h4>
      <div class="first_state" v-show="step == 0">
        <form action="">
          <p>{{ $t('login.provide_phone') }}</p>
          <fieldset>
            <label><span class="hint">{{ $t('login.phone') }}</span>
              <span class="prefix">+380</span><input type="tel" id="tel" autocomplete="off" v-model="loginData.phone" v-mask="'(##) ### ####'" placeholder="(00) XXX XXXX" value="38">
            </label>
          </fieldset>
          <button type="submit" :class="{'active': phoneValid}" @click.prevent="requestSMS">{{ $t('login.next') }}</button>
        </form>
          <p class="error" v-if="tooManySmsRequests">{{ $t('login.too_many_requests') }}</p>
      </div>
    </div>
    <div class="state" v-show="step == 1">
      <h4 class="component_heading">{{ $t('login.heading') }}</h4>
      <p class="back" @click="backToPhone">&lt;&lt; {{ $t('login.back') }}</p>
      <p class="top_p">{{ $t('login.to_phone') }}
        <b>+380 {{ loginData.phone }}</b> {{ $t('login.sent_sms') }}</p>
        <label for="code">
          <p class="input_hint">{{ $t('login.code_from_sms') }}</p>
          <input ref="codeInput" type="number" id="code" autocomplete="off" required="" v-model="loginData.pass" v-mask="'######'">
        </label>
        <p class="error" v-if="codeVerifyErr">{{ $t('login.wrong_code') }}</p>
      <div class="button" type="submit" :class="{'active': passValid}" @click="authorize">{{ $t('login.enter') }}</div>
      <p class="status waiting" v-if="smsStatus.status == 1">{{ $t('login.sms_sent_waiting') }}</p>
      <p class="status success" v-if="smsStatus.status == 2">{{ $t('login.code_delivered') }} <span v-if="smsStatus.hyber_status == 23022">{{ $t('login.in_push') }}</span><span v-if="smsStatus.hyber_status == 23011">{{ $t('login.in_sms') }}</span><span v-if="smsStatus.hyber_status == 23033">{{ $t('login.in_viber') }}</span></p>
      <div class="errors" v-if="smsStatus.status == 3">
        <p class="status error" v-if="resetByBrowserTimeout">{{ $t('login.delivery_service_down') }}</p>
        <p class="status error" v-if="smsStatus.substatus == 35">{{ $t('login.mes_expired') }}</p>
        <p class="status error" v-if="smsStatus.substatus == 37">{{ $t('login.cell_problems') }}</p>
        <div class="button active" style="width: 100%" @click="retry">{{ $t('login.resend_sms') }}</div>
      </div>
      <div class="button active" style="width: 100%" @click="retry" v-if="resetByBrowserTimeout">{{ $t('login.resend_sms') }}</div>
    </div>
  </div> -->
  <div class="login__wrapper">
    <div class="wd login__wd">
      <div class="login__left">
        <div class="login__form">
          <div class="login__left__header">
            <a href="https://multiplex.ua">
              <img
                src="../../assets/img/preloader_dt.svg"
                class="login__logo"
              />
            </a>
            <p class="login__heading">{{ $t("login.heading") }}</p>
          </div>
          <div
            class="login__step1"
            v-show="step === 0"
          >
            <!-- Видалит -->
            <!-- Видалит -->
            <!-- Видалит -->
            <!-- <p class="login__step__heading">{{ $t("login.provide_phone") }}</p> -->
            <!-- Видалит -->
            <!-- Видалит -->
            <!-- Видалит -->
            <p class="login__step__info">{{ $t("login.here_all") }}</p>

            <div class="login__wrap__input__description__login__label">
              <p class="login__input__description">{{ $t("login.phone") }}</p>
              <div class="login__wrap__input__supbmit">
                <label class="login__label">
                  <p class="login__phone__prefix">+380</p>
                  <input
                    type="tel"
                    class="login__input login__phone__input"
                    id="tel"
                    autocomplete="off"
                    v-model="loginData.phone"
                    v-mask="'(##) ### ####'"
                    placeholder="(00) XXX XXXX"
                    @keyup.enter="requestSMS"
                  />
                </label>
                <div
                  class="login__phone__submit"
                  :class="{ active: phoneValid && !smsRequested }"
                  @click.prevent="requestSMS"
                >
                  {{ $t("login.send_code") }}
                </div>
              </div>
            </div>

            <p
              class="login__codeerr"
              v-if="tooManySmsRequests"
            >
              {{ $t("login.too_many_requests") }}
            </p>
            <p
              class="login__codeerr"
              v-if="serviceUnavailable"
            >
              {{ $t("login.service_unavailable") }}
            </p>
            <!-- Показується повідомлення від сервера у випадку коли: серверне повідомлення має текст і не показується рекаптча -->
            <p
              class="login__codeerr"
              v-if="serverMessage !== '' && !isEnableRecaptcha"
            >
              {{ serverMessage }}
            </p>
          </div>
          <div
            class="login__step2"
            v-show="step === 1"
          >
            <!-- <p class="login__step__heading">{{ $t("login.confirm_phone") }}</p> -->
            <p class="login__step__info nomargin">
              {{ $t("login.enter_code") }}
            </p>
            <div class="login__submitted__phone">
              <p class="login__submitted__phone__val">
                +380 {{ loginData.phone }}
              </p>
              <!-- <div class="login__submitted__phone__change" @click="backToPhone">{{ $t("login.change_phone") }}</div> -->
              <div
                class="login__submitted__phone__change_2"
                @click="backToPhone"
              >
                {{ $t("login.change_phone") }}
              </div>
            </div>

            <div class="
                flex-center-max-1024
                max-width-vw-code-input-mob
                margin-gorizontal-auto
              ">
              <p class="login__input__description ml-vw-mob">
                {{ $t("login.code_from_sms") }}
              </p>
              <div
                class="login__code__inputs__holder"
                :class="{ err: codeVerifyErr }"
              >
                <input
                  type="tel"
                  class="login__input login__code__input"
                  maxlength="1"
                  ref="code_char0"
                  @keyup.right="focusNext(0)"
                  v-model="code_char0"
                />
                <input
                  type="tel"
                  class="login__input login__code__input"
                  maxlength="1"
                  ref="code_char1"
                  @keyup.right="focusNext(1)"
                  @keyup.8="focusPrev(1)"
                  @keyup.left="focusPrev(1)"
                  v-model="code_char1"
                />
                <input
                  type="tel"
                  class="login__input login__code__input"
                  maxlength="1"
                  ref="code_char2"
                  @keyup.right="focusNext(2)"
                  @keyup.8="focusPrev(2)"
                  @keyup.left="focusPrev(2)"
                  v-model="code_char2"
                />
                <input
                  type="tel"
                  class="login__input login__code__input"
                  maxlength="1"
                  ref="code_char3"
                  @keyup.right="focusNext(3)"
                  @keyup.8="focusPrev(3)"
                  @keyup.left="focusPrev(3)"
                  v-model="code_char3"
                />
                <input
                  type="tel"
                  class="login__input login__code__input"
                  maxlength="1"
                  ref="code_char4"
                  @keyup.right="focusNext(4)"
                  @keyup.8="focusPrev(4)"
                  @keyup.left="focusPrev(4)"
                  v-model="code_char4"
                />
                <input
                  type="tel"
                  class="login__input login__code__input"
                  maxlength="1"
                  ref="code_char5"
                  @keyup.8="focusPrev(5)"
                  @keyup.left="focusPrev(5)"
                  v-model="code_char5"
                />
              </div>
            </div>
            <p
              class="login__codeerr"
              v-if="codeVerifyErr"
            >
              {{ $t("login.wrong_code") }}
            </p>
            <div
              class="messages"
              v-if="serverMessage !== ''"
            >
              <p class="login__codeerr dev-info--server-message">
                {{ serverMessage }}
              </p>
              <div
                class="wrap-help"
                style=""
              >
                <!-- <p class="help-link">
                  <span></span><a href="https://multiplex.ua/about" class="link">Help</a>
                </p> -->
                <p class="help-link">
                  <span></span><a
                    href="https://multiplex.ua/faq"
                    class="link"
                  >FAQ</a>
                </p>
              </div>
            </div>
            <div
              class="login__codestatus"
              v-if="smsStatus.status == 1 && !resetByBrowserTimeout"
            >
              <img
                src="/static/img/loading.svg"
                class="login__codestatus__icon"
              />
              <p class="login__codestatus__text">
                {{ $t("login.sms_sent_waiting") }}
              </p>
            </div>
            <div
              class="login__codestatus"
              v-if="smsStatus.status == 2"
            >
              <img
                src="/static/img/done.svg"
                class="login__codestatus__icon"
              />
              <p class="login__codestatus__text">
                {{ $t("login.code_delivered") }}
                <span v-if="smsStatus.hyber_status == 23022">{{
                  $t("login.in_push")
                }}</span><span v-if="smsStatus.hyber_status == 23011">{{
                  $t("login.in_sms")
                }}</span><span v-if="smsStatus.hyber_status == 23033">{{
                  $t("login.in_viber")
                }}</span>
              </p>
            </div>

            <div
              class="login__codestatus"
              v-if="smsStatus.status == 3"
            >
              <img
                src="/static/img/error.svg"
                class="login__codestatus__icon"
              />
              <!-- <p class="login__codestatus__text" v-if="resetByBrowserTimeout">{{ $t('login.delivery_service_down') }}</p> -->
              <p
                class="login__codestatus__text"
                v-if="smsStatus.substatus == 35"
              >
                {{ $t("login.mes_expired") }}
              </p>
              <p
                class="login__codestatus__text"
                v-if="smsStatus.substatus == 36"
              >
                {{ $t("login.mes_unknown") }}
              </p>
              <p
                class="login__codestatus__text"
                v-if="smsStatus.substatus == 37"
              >
                {{ $t("login.cell_problems") }}
              </p>
            </div>

            <!-- Показати кнопку "Отправить код еще раз" -->
            <!-- Якщо від сервера немає повідомлень і статус смс = 3 -->
            <!-- (на даному кроці, повідмлення від сервера означає помилка) -->
            <!-- (статус sms = 3, - користувач не отримав sms) -->
            <div
              v-if="serverMessage !== '' && smsStatus.status == 3"
              class="login__resend__code"
              :class="{
                active: resetByBrowserTimeout || smsStatus.status == 3,
              }"
              @click.prevent="retry"
            >
              <span>{{ $t("login.resend") }}</span>
              <span v-if="!resetByBrowserTimeout && !(smsStatus.status == 3)">
                {{ $t("login.after") }} {{ resendCodeCtr }} сек.</span>
            </div>
            <!-- Показати кнопку "Отправить код еще раз" -->

            <!-- <div class="login__resend__code" :class="{'active': resetByBrowserTimeout || smsStatus.status == 3}" @click.prevent="retry">{{ $t('login.resend') }} <span v-if="!resetByBrowserTimeout && !(smsStatus.status == 3)">{{ $t('login.after') }} {{ resendCodeCtr }} сек.</span></div> -->
          </div>
          <!-- <div class="login__step3" v-show="step === 2">
            <p class="login__step__heading">Multiplex всегда с Вами</p>
            <p class="login__step__info mar16">С нашим мобильным приложением билеты всегда под рукой! </p>
            <p class="login__step__info">
              Отправить ссылку на приложение на номер:<br>
              <span class="login__app__phone">+380 {{ loginData.phone }}</span>?
            </p>
            <div class="login__app__buttons">
              <div class="login__app__button yes" @click="requestAppSMS">Да</div>
              <div class="login__app__button no" @click="sendInside">Пропустить</div>
            </div>
          </div> -->

          <!-- Login width OpenId -->
          <div class="login__wrap__social__logins">
            <div class="login__wrap__social__title">
              <div class="stripe"></div>
              <span class="title">або увійти за допомогою</span>
            </div>

            <div class="login__wrap__social__links">
              <FacebookBtn />
              <GoogleBtn />
              <AppleBtn />
            </div>
          </div>
          <!-- Login width OpenId -->

          <div class="wrap-link mb-20 relative">
            <span>{{ $t("login.back_to_MX") }}</span><a
              href="https://multiplex.ua"
              class="link"
            >Multiplex</a>

            <!-- Нижні дві горизотнтальні риски, що показують step1 або step2 -->
            <div class="login__nav">
              <div
                class="login__nav__el"
                :class="{ active: step === 0 }"
              ></div>
              <div
                class="login__nav__el"
                :class="{ active: step === 1 }"
              ></div>
              <!-- <div class="login__nav__el" :class="{'active': step === 2}"></div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="login__right">
        <div class="login__promo">
          <img
            src="/static/img/lk_login_img_new.png"
            class="login__promo__ill"
          />
          <p class="login__promo__heading">
            {{ $t("login.no_download_print") }}
          </p>
          <p class="login__promo__description">
            {{ $t("login.all_in_cabinet") }}
          </p>
        </div>
      </div>
    </div>

    <modal-popup
      v-show="isShowModal"
      :title="$t(`pop_ups.login_page.open_id_exception.title`)"
      :text="$t(`pop_ups.login_page.open_id_exception.${popupType}.text`)"
      :textBtnPrimary="$t(`pop_ups.login_page.open_id_exception.btns.primary`)"
      :textBtnSecondary="$t(`pop_ups.login_page.open_id_exception.btns.secondary`)"
      @eventCloseModal="closeModal"
    />
  </div>
</template>
<script>
import Store from '../../store'
import FacebookBtn from './open-id-buttons/FacebookBtn.vue'
import GoogleBtn from './open-id-buttons/GoogleBtn.vue'
import AppleBtn from './open-id-buttons/AppleBtn.vue'

export default {
  data: function () {
    return {
      loginData: {
        phone: '',
        pass: ''
      },
      code_char0: '',
      code_char1: '',
      code_char2: '',
      code_char3: '',
      code_char4: '',
      code_char5: '',
      step: 0,
      polling: null,
      pollingTimeout: null,
      resetByBrowserTimeout: false,
      browserTimeout: null,
      smsStatus: {
        // По замовчуванню не показуємо прелоадер очікувння SMS коду
        status: -1,
        substatus: -1
      },
      codeVerifyErr: false,
      tooManySmsRequests: false,
      serviceUnavailable: false,
      serverMessage: '',
      resendCodeCtr: 60,
      codeCountDown: null,
      smsRequested: false,
      /**
       * Модальне вікно якщо неуспішна авторизація через соціальні мережі
       * @ true - Показати
       * @ false - Сховати
       */
      isShowModal: false,
      popupType: 'unconnected',
      isEnableRecaptcha: false
    }
  },
  components: {
    FacebookBtn,
    GoogleBtn,
    AppleBtn
  },
  watch: {
    code_char0: function (val) {
      if (val.length > 0) {
        this.$refs['code_char1'].focus()
      }
    },
    code_char1: function (val) {
      if (val.length > 0) {
        this.$refs.code_char2.focus()
      }
    },
    code_char2: function (val) {
      if (val.length > 0) {
        this.$refs.code_char3.focus()
      }
    },
    code_char3: function (val) {
      if (val.length > 0) {
        this.$refs.code_char4.focus()
      }
    },
    code_char4: function (val) {
      if (val.length > 0) {
        this.$refs.code_char5.focus()
      }
    },
    // code_char5: function (val) {
    //   if (val.length > 0) {
    //     this.$refs.code_char1.focus()
    //     console.log(this.fullpass)
    //   }
    // },
    fullpass: function (val) {
      if (val.length === 6) {
        this.authorize()
      }
    }
  },
  computed: {
    fullpass: function () {
      return (
        this.code_char0 +
        this.code_char1 +
        this.code_char2 +
        this.code_char3 +
        this.code_char4 +
        this.code_char5
      )
    },
    trimmedPhone: function () {
      // console.log(this.loginData.phone.replace(/[+() ]/g, ''))
      return this.loginData.phone.replace(/[+() ]/g, '')
    },
    phoneValid: function () {
      return this.trimmedPhone.match(/\d{9}/)
    },
    passValid: function () {
      return this.loginData.pass.match(/^\d{6}$/)
    }
  },
  methods: {
    focusNext: function (n) {
      var next = (n + 1).toString()
      this.$refs['code_char' + next].focus()
    },
    focusPrev: function (n) {
      var prev = (n - 1).toString()
      this.$refs['code_char' + prev].focus()
    },
    authorize: function () {
      this.$http
        .post('https://auth2.multiplex.ua/verify', { password: this.fullpass })
        .then(
          (response) => {
            // if (!this.$cookie.get('friends-app-shown')) {
            //   this.$cookie.set('friends-app-shown', 'yes', {expires: 365, domain: '.multiplex.ua'})
            //   this.step = 2
            // } else {
            //   this.sendInside()
            // }
            // this.serverMessage = text
            this.setServerMessage(response.body.Message)
            this.sendInside()
          },
          (response) => {
            if (response.status === 401) {
              this.codeVerifyErr = true
            }
            this.checkStopRequestSMSBy400(response.status)
          }
        )
    },
    sendInside: function () {
      clearInterval(this.polling)
      Store.dispatch('getUser', () => {
        Store.dispatch('getDicts', () => {
          this.$router.push('/')
        })
      })
    },
    requestAppSMS: function () {
      alert('SMS REQUESTED')
      this.sendInside()
    },
    requestSMS: function () {
      this.smsRequested = true
      this.tooManySmsRequests = false
      this.serviceUnavailable = false
      this.$http
        .post('https://auth2.multiplex.ua/login', {
          login: '380' + this.trimmedPhone
        }, {
          headers: {
            'X-MX-Source': 'WEB-FRIENDS'
          }
        })
        .then(
          (response) => {
            this.setServerMessage(response.body.Message)
            // Якщо SmsStatus = true -> опитуємо сервер на ендопінт /status, false - припиняємо опитування
            if (!response.body.SmsStatus) {
              this.stopRequestingSMS()
            }

            if (response.body.Recaptcha) {
              this.isEnableRecaptcha = true
              this.executeRecaptcha()
              return
            }

            this.setStep1()
            this.smsRequested = false
            if (!response.body.err) {
              this.resetByBrowserTimeout = false
              this.requestSMSStatus()
              this.startCountDown()
              this.setFocusAtChar0()
            }
          },
          (response) => {
            this.smsRequested = false
            if (response.status === 401) {
              this.tooManySmsRequests = true
            } else {
              this.serviceUnavailable = true
            }
            this.checkStopRequestSMSBy400(response.status)
          }
        )
    },
    startCountDown: function () {
      this.resendCodeCtr = 60
      this.codeCountDown = setInterval(() => {
        this.resendCodeCtr -= 1
        if (this.resendCodeCtr <= 0) {
          this.letResendSMS()
        }
      }, 1000)
    },
    letResendSMS: function () {
      clearInterval(this.codeCountDown)
      this.resetByBrowserTimeout = true
    },
    requestSMSStatus: function () {
      clearInterval(this.polling)
      this.polling = setInterval(() => {
        this.$http.get('https://auth2.multiplex.ua/status').then(
          (response) => {
            this.setServerMessage(response.body.Message)
            this.smsStatus = response.body
            if (response.body.status !== 1) {
              this.stopRequestingSMS()
              this.resetByBrowserTimeout = false
            }
          },
          (response) => {
            console.log('Failure')
            this.checkStopRequestSMSBy400(response.status)
          }
        )
      }, 2000)
      // this.browserTimeout = setTimeout(() => {
      //   this.resetByBrowserTimeout = true
      // }, 20000)
    },
    checkStopRequestSMSBy400: function (restStatus) {
      if (restStatus === 400) {
        this.stopRequestingSMS()
      }
    },
    backToPhone: function () {
      this.step = 0
      this.stopRequestingSMS()
      // Зробити кнопку прдовжити активною
      this.smsRequested = false
      // Сховати серверне повідомлення
      this.serverMessage = ''
      // Сховати внутрішнє повідомлення
      this.codeVerifyErr = false
      // Очистити поля для вводу вводу коду з SMS
      this.clearChars()
    },
    retry: function () {
      this.stopRequestingSMS()
      this.requestSMS()
    },
    auth2Response: function (url, notConnectedMsg) {
      this.$http.get(url).then(
        (response) => {
          if (response.status === 200) {
            window.location.replace(url)
          }
          if (response.status === 401) {
            alert(notConnectedMsg)
          }
        },
        (response) => {
          console.log('Bad request: ' + url)
          this.checkStopRequestSMSBy400(response.status)
        }
      )
    },
    commonFuncForRecaptcha: function ({ serverMessage }) {
      this.setStep1()
      this.clearChars()
      this.setFocusAtChar0()
      this.setServerMessage(serverMessage)
    },
    executeRecaptcha: function () {
      let _this = this
      window.grecaptcha.ready(function () {
        window.grecaptcha
          .execute(Store.state.reCAPTCHA_site_key, { action: 'submit' })
          .then(function (token) {
            _this.$http
              .post('https://auth2.multiplex.ua/captcha', { token })
              .then(
                (response) => {
                  _this.commonFuncForRecaptcha({
                    serverMessage: response.body.Message
                  })

                  // Якщо SmsStatus = true -> опитуємо сервер на ендопінт /status, false - припиняємо опитування
                  if (response.body.SmsStatus) {
                    _this.requestSMSStatus()
                  }
                },
                (response) => {
                  console.error(response)
                  _this.checkStopRequestSMSBy400(response.status)
                }
              )
          })
      })
    },
    stopRequestingSMS: function () {
      clearInterval(this.polling) // зупинити опитування сервера на статус SMS
      clearTimeout(this.browserTimeout)
    },
    setServerMessage: function (text) {
      this.serverMessage = text
    },
    setStep1: function () {
      this.step = 1
    },
    clearChars: function () {
      this.code_char0 = ''
      this.code_char1 = ''
      this.code_char2 = ''
      this.code_char3 = ''
      this.code_char4 = ''
      this.code_char5 = ''
    },
    setFocusAtChar0: function () {
      this.$nextTick(() => this.$refs.code_char0.focus())
    },
    /**
     * Перевірка чи показувати модальне вікно, якщо в параметрах URL є ознака неуспішного входу через соціальні мережі
     * @ #unconnected немає прив'язаних облікових записів
     * @ #unauthorized соціальна мережа не авторизувала користувача
     */
    checkServerRedirectExceptionForOpenId: function () {
      let url = new URL(window.location.href)
      if (url.pathname === '/login') {
        if (url.hash === '#unconnected') {
          this.isShowModal = true
          this.popupType = 'unconnected'

          let cookieUnconnectedOpenId =
            Store.state.constants.cookie.unconnectedOpenId
          this.$cookie.set(cookieUnconnectedOpenId.name, true, {
            expires: cookieUnconnectedOpenId.expires,
            domain: cookieUnconnectedOpenId.domain
          })
        }

        if (url.hash === '#unauthorized') {
          this.isShowModal = true
          this.popupType = 'unauthorized'
        }
      }
    },
    closeModal: function () {
      this.isShowModal = false
    }
  },
  mounted: function () {
    this.checkServerRedirectExceptionForOpenId()

    const ck = this.$cookie.get('UserInfo')
    if (ck) {
      const ckSplit = ck.split('&')
      let ckObj = {}
      for (let i = 0; i < ckSplit.length; i++) {
        const pair = ckSplit[i].split('=')
        ckObj[pair[0]] = pair[1]
      }
      this.loginData.phone = ckObj['UserPhone'].substring(4)
    }

    // Фокус в інпут телефона
    const tel = document.getElementById('tel')
    if (tel) tel.focus()

    Store.getters.loadGoogleRecatchaLib()
  }
}
</script>



// WEBPACK FOOTER //
// wrapper.vue?657c5373